module.exports = __webpack_public_path__ + "static/placeholder-b861a37bad3b16b4f41f25ce74cc5cf9.jpg";